import { useState, useEffect } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Cog8ToothIcon } from "@heroicons/react/24/outline";
import OrderIcon from "@/public/order.svg";
import Image from "next/image";
import { Caption } from "@/components/ui/typography";
import { User } from "@/lib/SystemIcons";
import { UserRoundMinus, UserRoundPlus } from "lucide-react";
import {
  getCookieValue,
  removeCookieValue,
  removeNextAuthSession,
} from "@/app/utils/utility";
import {
  setCartSynced,
  setStoreCartItems,
} from "@/app/redux/cart-management/cart-management-slice";

import Link from "next/link";
import { useDispatch } from "react-redux";
import { persistor } from "@/app/redux/config/store";
import { Button } from "@/components/ui/button";
import { useShowSnackbar } from "@/app/hooks/useSnackbar";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";
export default function UserDropDown() {
  // State to track the token
  const dispatch = useDispatch();
  const [token, setToken] = useState(getCookieValue("accessToken"));
  const router = useRouter();
  const { showSnackbar } = useShowSnackbar();
  // Effect to listen for token changes (e.g., login/logout)
  useEffect(() => {
    // You can add more advanced token change detection logic here if necessary
    const handleTokenChange = () => {
      setToken(getCookieValue("accessToken"));
    };
    if (!token) {
      dispatch(setCartSynced(false));
      // dispatch(setStoreCartItems({ items: [] }));
    }
    // Example: listen to storage changes (if using localStorage or cookie manipulation elsewhere)
    window.addEventListener("storage", handleTokenChange);

    return () => {
      window.removeEventListener("storage", handleTokenChange);
    };
  }, []);

  // Handle logout logic
  const handleLogout = async () => {
    removeCookieValue("accessToken");
    removeCookieValue("loggedEmail");
    removeNextAuthSession();
    await persistor.purge();
    setToken(null);
  
    // Redirect to homepage manually if needed
    window.location.href = "/";
  };

  useEffect(()=>{
    let tokenExpTime = getCookieValue('Token-exp');
    let token = getCookieValue('accessToken');
    let currentLocalDate = new Date();
    const tokenExpLocalDate = new Date(tokenExpTime*1000);
    console.log(currentLocalDate, tokenExpLocalDate,'token-exp')
    if(currentLocalDate >= tokenExpLocalDate && token){
      handleLogout();
    }
    },[])

  const useStore = useSelector((state) => state.auth);
  const isUserLoggedIn = !!useStore?.userLoginDetails?.email.length;

  if (token) {
    return (
      <DropdownMenu>
        <>
          <DropdownMenuTrigger asChild>
            <User className="h-[26px] w-[26px] text-midnightIndigo-400" />
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-[296px] mt-4 mx-3 z-[99] p-0">
            <DropdownMenuLabel className="px-4 pt-4 pb-3">
              <Caption
                size="sm"
                className="text-midnightIndigo-300 font-normal"
              >
                My account
              </Caption>
            </DropdownMenuLabel>
         
            <DropdownMenuItem className="rounded-none hover:!bg-midnightIndigo-200 wireless-Medium cursor-pointer py-0 px-0">
              <Link
                href="/orders"
                className="w-full gap-2 items-center flex px-4 py-2"
              >
                <Image src={OrderIcon} height={20} width={20} alt="Order Icon" />{" "}
                <span className="pt-[3px]">My Orders</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem className="rounded-none hover:!bg-midnightIndigo-200 wireless-Medium cursor-pointer py-0 px-0">
              <Link
                href="/accountsetting"
                className="w-full gap-2 items-center flex px-4 py-2"
              >
                <Cog8ToothIcon className="size-6 " />
                <span className="mt-1">Account Settings</span>
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator className="mx-4  bg-system-light" />
            <DropdownMenuItem
              className="flex p-4 rounded-none hover:!bg-midnightIndigo-200 cursor-pointer wireless-Medium"
              onClick={handleLogout}
            >
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </>
      </DropdownMenu>
    );
  } else {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <UserRoundPlus className="h-[25px] w-[25px] text-midnightIndigo-400 " />
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[296px] mt-4 mx-3 z-[99] ">
          <DropdownMenuItem className="flex gap-1 py-2 cursor-pointer hover:bg-none focus:bg-white">
            <Button size="xl" onClick={() => router.push("/sign-up")}>
              Sign up
            </Button>
          </DropdownMenuItem>
          <DropdownMenuItem className="flex gap-1 py-2  cursor-pointer hover:bg-none focus:bg-white">
            <Button
              variant="outline"
              size="xl"
              className="focus:bg-none"
              onClick={() => (window.location.href = "/sign-in")}
            >
              Sign In
            </Button>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
}
